import { clientSDK } from "@istari-frontend/api-client";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { DEFAULT_CACHE_TIME, QUERY_GC_TIME_MS_30M } from "~/constants";

import { toControlTagSummaries } from "./adapter/to-control-tag-summary";

export const controlTagQueryKeys = {
  catalog: ["control-tags", "catalog"] as const,
};

async function fetchControlTags() {
  try {
    return await clientSDK.listControlTags();
  } catch (error) {
    console.error(error);
    throw new Error("An error occurred while fetching control tags.", { cause: error });
  }
}

export const controlTagCatalogQueryOptions = queryOptions({
  queryKey: controlTagQueryKeys.catalog,
  queryFn: fetchControlTags,
  staleTime: DEFAULT_CACHE_TIME,
  gcTime: QUERY_GC_TIME_MS_30M,
  refetchOnWindowFocus: false,
});

export function useControlTags() {
  return useQuery({
    ...controlTagCatalogQueryOptions,
    select: toControlTagSummaries,
  });
}
